















































































import { mapState } from "vuex";

import { Component, Vue, Watch } from "vue-property-decorator";
import { PaymentWithUser } from "@/interfaces/payment";
import { Route } from "vue-router";
import { Tenant } from "@/interfaces/tenants";
import { TenantApiClient } from "@/api/tenant_client";
import CardComponent from "@/components/CardComponent.vue";

@Component({
  computed: {
    ...mapState(["tenants"])
  },
  components: { CardComponent }
})
export default class BankTransfers extends Vue {
  // Mapped from vuex
  tenants!: Tenant[];

  // Other Variables
  private api = new TenantApiClient();

  public tenant: Tenant = {
    name: "",
    description: "",
    web_url: "",
    tenant_id: ""
  };

  public transfers: PaymentWithUser[] = [];
  public perPage = 25;
  public isLoading = true;

  public defaultThumbnailUrl: string =
    process.env.VUE_APP_DEFAULT_THUMBNAIL_URL;

  mounted() {
    this.setTenant(this.$route.params.tenant_id);
    this.loadContent();

    this.$store.commit("clearBreadcrumbs");
    this.$store.commit("pushBreadcrumbs", {
      to: `/tenant/${this.tenant.tenant_id}`,
      label: this.tenant.name
    });
    this.$store.commit("pushBreadcrumbs", {
      label: "Überweisungen"
    });
  }

  // Watchers
  @Watch("$route")
  onRouteChange(newValue: Route) {
    this.setTenant(newValue.params.tenant_id);
    this.loadContent();
  }

  loadContent() {
    this.isLoading = true;
    this.api
      .getBanktransfers(this.tenant.tenant_id)
      .then(transfers => {
        this.transfers = transfers;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  setTenant(tenantId: string) {
    this.tenants.forEach(tenant => {
      if (tenant.tenant_id === tenantId) {
        this.tenant = tenant;
      }
    });
  }

  async acceptPayment(payment: PaymentWithUser) {
    await this.api.acceptBanktransfer(
      this.tenant.tenant_id,
      payment.user_id,
      payment.payment_id
    );
    this.loadContent();
  }

  mapStatus(status: string): string {
    const statusMap: any = {
      INITIATED: "Neue Überweisung",
      CANCELED_CUSTOMER: "Vom User abgebrochen",
      SUCCESS: "Erfolgreich abgeschlosssen"
    };
    return statusMap[status] || status;
  }
}
